import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListIndustries } from "../../../components/Admin/Industries";
import { useLanguage } from "../../../contexts";
import "./Industries.scss";

export function Industries() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_industries"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListIndustries industriesActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_industries"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListIndustries industriesActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="industries-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="industries-page-header-wrapper">
        <div className="industries-page-header">
          <span className="industries-page-title">{t("industries")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
